import {GenSyncLocation} from '../generated/serverModels/GenSyncLocation';
import {GenSyncProject} from '../generated/serverModels/GenSyncProject';
import {GenSyncTask} from '../generated/serverModels/GenSyncTask';
import {GenSyncUser} from '../generated/serverModels/GenSyncUser';
import {GenTaskSyncImportResult} from '../generated/serverModels/GenTaskSyncImportResult';
import {GenTaskSyncManifest} from '../generated/serverModels/GenTaskSyncManifest';

export class TaskSyncManifest extends GenTaskSyncManifest {
  projects: SyncProject[];
  tasks: SyncTask[];

  constructor(input?: any) {
    super(input);
    this.projects = this.projects?.map(project => new SyncProject(project)) || [];
    this.tasks = this.tasks?.map(task => new SyncTask(task)) || [];
  }
}

export class SyncProject extends GenSyncProject {
  members: SyncUser[];
  pointOfContact: SyncUser;

  constructor(input?: any) {
    super(input);
    this.members = this.members?.map(member => new SyncUser(member)) || [];
    this.pointOfContact = this.pointOfContact ? new SyncUser(this.pointOfContact) : undefined;
  }
}

export class SyncTask extends GenSyncTask {
  contributor: SyncUser;
  location: SyncLocation;

  constructor(input?: any) {
    super(input);
    this.contributor = this.contributor ? new SyncUser(this.contributor) : undefined;
    this.location = this.location ? new SyncLocation(this.location) : undefined;
  }
}

export class SyncUser extends GenSyncUser {
}

export class SyncLocation extends GenSyncLocation {
}

export class TaskSyncImportResult extends GenTaskSyncImportResult {
}
